import { IconName } from "../Icon/types";

export const ALERT_ICON: Record<string, IconName> = {
  success: "success",
  error: "error",
  warning: "warning",
};
